const toBase64Url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/**
 * An RFC 7636 S256 pair: 32 random octets base64url-encode to a 43-character
 * verifier, the minimum length the spec allows.
 */
export const createPkcePairAsync = async () => {
  const codeVerifier = toBase64Url(crypto.getRandomValues(new Uint8Array(32)));
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(codeVerifier),
  );

  return { codeVerifier, codeChallenge: toBase64Url(new Uint8Array(digest)) };
};
